// extracted by mini-css-extract-plugin
export default {"popupWrapper":"DetailPopup_popupWrapper__74JI8","parentDiv":"DetailPopup_parentDiv__H4-J5","contentDiv":"DetailPopup_contentDiv__3V5NZ"};